import getCurrentSetStartWorkoutSelector from '../../../../start-workout/selectors/get-current-set'
import hasStartedStartWorkoutSelect from '../../../../start-workout/selectors/has-started'
import { getCurrentSetWorkoutExerciseSelect } from '../../../../workout-exercise/redux/selectors/get-current-set'
import { getCircuitRoundsWorkoutSectionSelector } from '../get-circuit-data'
import { createSelector } from 'reselect'

const getCircuitCurrentRoundIndexWorkoutSectionSelect = createSelector(
  hasStartedStartWorkoutSelect,
  getCircuitRoundsWorkoutSectionSelector,
  getCurrentSetWorkoutExerciseSelect,
  getCurrentSetStartWorkoutSelector,
  (hasStartedWorkout, circuitRounds, currentSet, currentStartedSet) => {
    if (!circuitRounds) {
      return
    }

    let set
    if (hasStartedWorkout) {
      set = currentStartedSet
    } else {
      set = currentSet
    }

    if (!set) {
      return
    }

    const roundIndex = circuitRounds.findIndex(round => {
      return round.find(roundSet => roundSet.set === set)
    })
    return roundIndex > -1
      ? roundIndex
      : 0
  }
)

export default getCircuitCurrentRoundIndexWorkoutSectionSelect
